module.exports = __webpack_public_path__ + "media/check.3486626a.svg";